import { DetailedHTMLProps, HTMLAttributes, PropsWithChildren } from 'react';

import styles from '@components/typography/Typography.module.css';

type Props = PropsWithChildren<
  DetailedHTMLProps<HTMLAttributes<HTMLHeadingElement>, HTMLHeadingElement> & {
    bold?: boolean;
    color?: 'primary700' | 'primary500' | 'neutral200' | 'shadesWhite' | 'neutral500' | 'neutral300' | 'primary300';
  }
>;

const Heading2 = ({ bold = true, children, className, color = 'primary700', ...headingProps }: Props) => {
  const fullClassNames = [className, styles.heading2, styles[color], bold && styles.normalWeight]
    .filter(klass => !!klass)
    .join(' ');
  return (
    <h2 className={fullClassNames} {...headingProps}>
      {children}
    </h2>
  );
};

export default Heading2;
